<template>
    <h1 v-if="isStatic">
        <slot></slot>
    </h1>
    <h1 v-else>
        <div v-for="(text, i) in text" :key="i" :ref="'container_' + i">
            <i>&nbsp;</i>
        </div>
    </h1>
</template>

<script>
export default {
    props: ['text'],
    data() {
        return {
            currentTick: 0
        }
    },
    mounted() {
        if (!this.isStatic)
            this.startTextAnimation(0);
    },
    computed: {
        isStatic() {
            return typeof window.__PRERENDER_INJECTED !== 'undefined'
        }
    },
    methods: {
        typeWriter(text, i, textIndex, fnCallback) {
            if (i < (text.length)) {
                this.getContainer(textIndex).innerHTML = text.substring(0, i+1) +'<span aria-hidden="true"></span><i>&nbsp;</i>';

                setTimeout(() => {
                    this.typeWriter(text, i + 1, textIndex, fnCallback)
                }, this.random(40, 75));
            } else if (typeof fnCallback == 'function') {
                this.renderSuffix(textIndex, text);
                setTimeout(fnCallback, 1000);
            }
        },
        renderSuffix(textIndex, text) {
            this.currentTick = 0;
            setTimeout(() => {this.getContainer(textIndex).innerHTML = text + ' <i>&</i><span aria-hidden="true"></span>';}, this.tick());
            //setTimeout(() => {this.getContainer(textIndex).innerHTML = text + ' <i>&&</i><span aria-hidden="true"></span>';}, this.tick());
            setTimeout(() => {this.getContainer(textIndex).innerHTML = text + ' <i>&&</i>';}, this.tick());
            
            if (textIndex >= (this.text.length - 1)) {
                //setTimeout(() => {this.getContainer(textIndex).innerHTML = text + ' <i>AN</i><span aria-hidden="true"></span>';}, this.tick());
                setTimeout(() => {this.getContainer(textIndex).innerHTML = text + ' <i>&</i><span aria-hidden="true"></span>';}, this.tick());
                setTimeout(() => {this.getContainer(textIndex).innerHTML = text + ' <i></i><span aria-hidden="true"></span>';}, this.tick());
                setTimeout(() => {this.getContainer(textIndex).innerHTML = text + '<i>;</i><span aria-hidden="true"></span>';}, this.tick());
            }
        },

        getContainer(textIndex) { return this.$refs['container_' + textIndex][0]; },

        tick() {
            this.currentTick = this.currentTick + this.random();
            return this.currentTick;
        },
        random(min = 90, max = 175) {
            return Math.floor(Math.random()*(max-min+1)+min);
        },
        startTextAnimation(i) {
            if (typeof this.text[i] == 'undefined'){
               return;
            }

            if (i < this.text[i].length) {
                this.typeWriter(this.text[i], 0, i, () => {
                    this.startTextAnimation(i + 1);
                });
            }
        }
    }
}
</script>
<style lang="scss">
h1 span {
  border-right: .05em solid;
  animation: caret .75s steps(1) infinite;
  opacity: .25;
}

@keyframes caret {
  50% {
    border-color: transparent;
  }
}
</style>

